import Resizer from "react-image-file-resizer";

export function countWords(text) {
  // Remove leading/trailing whitespace and replace multiple spaces with a single space
  const cleanedText = text.trim().replace(/\s+/g, " ");
  // Split the string by spaces
  const words = cleanedText.split(" ");
  // Filter out empty strings that might result from splitting
  return words.filter((word) => word !== "").length;
}

//get time format
export function formatSecondsToMS(totalSeconds) {
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad with leading zeros if necessary
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");
  //return
  return `${formattedMinutes}:${formattedSeconds}`;
}

//check if valid email addess
export function isValidEmail(email) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  //return
  return emailRegex.test(email);
}

//is valid phone number
export function isValidPhoneNumber(number) {
  // A simple regex for 10-digit numbers (customize as needed)
  const regex = /^\d{10}$/;
  return regex.test(number);
}

//is valid name
export function isValidName(name) {
  const nameRegex = /^[a-zA-Z\s]+$/; // Allows letters and spaces
  return nameRegex.test(name);
}

//copyb text to clipboard
export async function copyTextToClipboard(textToCopy) {
  try {
    await navigator.clipboard.writeText(textToCopy);
    console.log("Text successfully copied to clipboard!", textToCopy);
  } catch (err) {
    console.error("Failed to copy text: ", err);
  }
}

//random int upto max
export function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}

//resize image
//resize 224*224
//size required for model
export const resizeImageFileForDetection224x224 = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      224, // maxWidth
      224, // maxHeight
      "JPEG", // compressFormat
      100, // quality
      0, // rotation
      (uri) => {
        resolve(uri);
      },
      "base64" // outputType
    );
  });

//get file extension
export function getExtension(filename) {
  return filename.split(".").pop();
}
